import { Accordion, AccordionDetails, AccordionSummary, Popper, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, { useState, useEffect, FC } from 'react';
import { useDispatch } from 'react-redux';

import { ReactComponent as SelectArrowIcon } from '../../_assets/images/select-arrow.svg';
import { IProfile, ITeams, otherTeamsInitialState, teamsInitialState } from '../../models/profile/teams';
import { useAppSelector } from '../../store';
import { getUserTeamsDataById, setProfileData } from '../../store/features/profile/profileSlice';

const CustomPopper = props => {
    return <Popper {...props} className="dropdown-01" placement="bottom" />;
};

const Teams: FC<IProfile> = ({ isEdit, isTouched }) => {
    const [teams, setTeams] = useState([]);
    const [basketballTeam, setBasketballTeam] = useState<ITeams>(teamsInitialState);
    const [voleyballTeam, setVoleyballTeam] = useState<ITeams>(teamsInitialState);
    const [footballTeam, setFootballTeam] = useState<ITeams>(teamsInitialState);
    const [otherTeam, setOtherTeam] = useState<ITeams>(otherTeamsInitialState);
    const [teamsData, setTeamsData] = useState<any>();
    const { basketballTeams, voleyballTeams, footballTeams, otherTeams, profileData, userTeams } = useAppSelector(state => state.profile);
    const { words } = useAppSelector(state => state.localization);
    const dispatch = useDispatch();

    const queryParams = new URLSearchParams(window.location.search);
    const userId_ = queryParams.get('u');

    useEffect(() => {
        if (userId_) {
            dispatch(getUserTeamsDataById(userId_));
        }
    }, [userId_]);

    useEffect(() => {
        setTeamsData(userTeams?.items);
    }, [userTeams])

    useEffect(() => {
        getUserTeams()
    }, [teamsData])

    const getUserTeams = () => {
        if (teamsData?.length === 0) {
            setOtherTeam(prev => ({
                ...prev,
                id: null,
                sportTeamId: null
            }));
            return;
        }

        if (teamsData?.some(x => x.sportType === 1)) {
            teamsData?.find(
                item =>
                    item.sportType === 1 &&
                    setBasketballTeam({
                        id: item?.id,
                        sportTeamId: item?.sportTeamId,
                        name: item?.isOther ? item?.sportTeamName : '',
                        isOther: item?.isOther,
                        teamName: item?.otherTeamTextName ? item?.otherTeamTextName : item?.sportTeamName,
                    }),
            );
        }

        if (teamsData?.some(x => x.sportType === 2)) {
            teamsData?.find(
                item =>
                    item.sportType === 2 &&
                    setVoleyballTeam({
                        id: item?.id,
                        sportTeamId: item?.sportTeamId,
                        name: item?.isOther ? item?.sportTeamName : '',
                        isOther: item?.isOther,
                        teamName: item?.otherTeamTextName ? item?.otherTeamTextName : item?.sportTeamName,
                    }),
            );
        }

        if (teamsData?.some(x => x.sportType === 3)) {
            teamsData?.find(
                item =>
                    item.sportType === 3 &&
                    setFootballTeam({
                        id: item?.id,
                        sportTeamId: item?.sportTeamId,
                        name: item?.isOther ? item?.sportTeamName : '',
                        isOther: item?.isOther,
                        teamName: item?.otherTeamTextName ? item?.otherTeamTextName : item?.sportTeamName,
                    }),
            );
        }

        if (teamsData?.some(x => x.sportType === 4)) {
            teamsData?.find(
                item =>
                    item.sportType === 4 &&
                    setOtherTeam({
                        id: item?.id,
                        sportTeamId: otherTeams?.items[0]?.id,
                        name: item?.sportTeamName,
                        isOther: true,
                        teamName: '',
                    }),
            );
        }
    };

    useEffect(() => {
        setTeams([basketballTeam, voleyballTeam, footballTeam, otherTeam]);
    }, [basketballTeam, voleyballTeam, footballTeam, otherTeam]);

    useEffect(() => {
        setOtherTeam({
            ...otherTeam,
            sportTeamId: otherTeams?.items[0]?.id,
        });
    }, [otherTeams?.items[0]?.id?.length > 0]);


    useEffect(() => {
        dispatch(
            setProfileData({
                ...profileData,
                teams,
            }),
        );
    }, [teams]);

    return (
        <div className="c-item">
            <Accordion defaultExpanded={true}>
                <AccordionSummary expandIcon="" aria-controls="panel3a-content" id="panel3a-header">
                    <div className="c-item-01">
                        <h6>{isEdit ? words && words['WEB.yourFavouriteTeam'] : words && words['WEB.fanOfTeams']}</h6>
                        <div className="c-item-01-B">
                            <svg className="c-unit-01" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M9.29183 3.29196C9.38473 3.19883 9.49508 3.12494 9.61657 3.07453C9.73806 3.02412 9.8683 2.99817 9.99983 2.99817C10.1314 2.99817 10.2616 3.02412 10.3831 3.07453C10.5046 3.12494 10.6149 3.19883 10.7078 3.29196L22.7078 15.292C22.801 15.3848 22.8748 15.4952 22.9253 15.6167C22.9757 15.7382 23.0016 15.8684 23.0016 16C23.0016 16.1315 22.9757 16.2617 22.9253 16.3832C22.8748 16.5047 22.801 16.6151 22.7078 16.708L10.7078 28.708C10.5201 28.8957 10.2654 29.0012 9.99983 29.0012C9.73428 29.0012 9.47961 28.8957 9.29183 28.708C9.10406 28.5202 8.99857 28.2655 8.99857 28C8.99857 27.7344 9.10406 27.4797 9.29183 27.292L20.5858 16L9.29183 4.70796C9.19871 4.61507 9.12482 4.50471 9.07441 4.38322C9.024 4.26173 8.99805 4.13149 8.99805 3.99996C8.99805 3.86842 9.024 3.73818 9.07441 3.61669C9.12482 3.4952 9.19871 3.38485 9.29183 3.29196Z"
                                    fill="#2e333e"
                                />
                            </svg>

                            <svg className="c-unit-02" width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M3.29183 9.79196C3.38473 9.69883 3.49508 9.62494 3.61657 9.57453C3.73806 9.52412 3.8683 9.49817 3.99983 9.49817C4.13137 9.49817 4.26161 9.52412 4.3831 9.57453C4.50459 9.62494 4.61494 9.69883 4.70783 9.79196L15.9998 21.086L27.2918 9.79196C27.3848 9.69898 27.4952 9.62523 27.6167 9.57491C27.7381 9.52459 27.8683 9.49869 27.9998 9.49869C28.1313 9.49869 28.2615 9.52459 28.383 9.57491C28.5045 9.62523 28.6149 9.69898 28.7078 9.79196C28.8008 9.88493 28.8746 9.99531 28.9249 10.1168C28.9752 10.2383 29.0011 10.3685 29.0011 10.5C29.0011 10.6314 28.9752 10.7616 28.9249 10.8831C28.8746 11.0046 28.8008 11.115 28.7078 11.208L16.7078 23.208C16.6149 23.3011 16.5046 23.375 16.3831 23.4254C16.2616 23.4758 16.1314 23.5017 15.9998 23.5017C15.8683 23.5017 15.7381 23.4758 15.6166 23.4254C15.4951 23.375 15.3847 23.3011 15.2918 23.208L3.29183 11.208C3.19871 11.1151 3.12482 11.0047 3.07441 10.8832C3.024 10.7617 2.99805 10.6315 2.99805 10.5C2.99805 10.3684 3.024 10.2382 3.07441 10.1167C3.12482 9.9952 3.19871 9.88485 3.29183 9.79196Z"
                                    fill="#2e333e"
                                />
                            </svg>
                        </div>
                    </div>
                </AccordionSummary>
                <AccordionDetails>
                    <div className="c-item-04">
                        <div className="c-item-04-A">
                            <div className="c-unit-01 form-group-04">
                                <>
                                    <label className="label-01">{words && words['WEB.basketBolTeams']}</label>
                                    <Autocomplete
                                        noOptionsText={words && words['WEB.resultNotFounded']}
                                        disabled={!isEdit}
                                        fullWidth={true}
                                        PopperComponent={CustomPopper}
                                        closeIcon=""
                                        id={'interestsCategory-' + basketballTeam?.sportTeamId}
                                        value={{ id: basketballTeam?.sportTeamId, name: basketballTeam?.teamName }}
                                        onChange={(e: any, val: any) =>
                                            setBasketballTeam({
                                                ...basketballTeam,
                                                sportTeamId: val?.id,
                                                teamName: val?.name,
                                                name: '',
                                                isOther: val?.isOther,
                                            })
                                        }
                                        getOptionLabel={(option: any) => (option && option?.name ? option?.name : '')}
                                        options={basketballTeams?.items.length > 0 ? basketballTeams.items : []}
                                        className="autocomplete-05"
                                        renderInput={params => (
                                            <div ref={params.InputProps.ref} className="render-container">
                                                <input
                                                    {...params.inputProps}
                                                    className="render-input-teams"
                                                    placeholder={words && words['WEB.noInformationShared']}
                                                />
                                                {isEdit && <SelectArrowIcon className="red-arrow" />}
                                            </div>
                                        )}
                                    />
                                </>

                                {basketballTeam?.isOther && (
                                    <div
                                        className={
                                            isTouched && !basketballTeam?.name
                                                ? 'c-unit-01 form-group-04 others error'
                                                : 'c-unit-01 form-group-04 others'
                                        }>
                                        <label className="label-01">{words && words['WEB.OTHER']}</label>
                                        <TextField
                                            disabled={!isEdit}
                                            className={isTouched && !basketballTeam?.name ? 'textfield-02 error' : 'textfield-02'}
                                            name="basketballOtherTeam"
                                            value={basketballTeam?.name?.length > 0 ? basketballTeam?.name : ''}
                                            id={'otherTeam-' + basketballTeam?.name}
                                            onChange={(e: any) =>
                                                setBasketballTeam({
                                                    ...basketballTeam,
                                                    name: e?.target?.value?.trim()?.length > 0 ? e?.target?.value : '',
                                                })
                                            }
                                            placeholder={words && words['WEB.noInformationShared']}
                                        />

                                        {isTouched && !basketballTeam?.name && (
                                            <span className="validation-error-message-01">*{words && words['WEB.requiredField']}</span>
                                        )}
                                    </div>
                                )}
                            </div>

                            <div className="c-unit-01 form-group-04">
                                <>
                                    <label className="label-01">{words && words['WEB.footballTeams']}</label>
                                    <Autocomplete
                                        noOptionsText={words && words['WEB.resultNotFounded']}
                                        disabled={!isEdit}
                                        fullWidth={true}
                                        PopperComponent={CustomPopper}
                                        closeIcon=""
                                        id={'interestsCategory-' + footballTeam?.sportTeamId}
                                        value={{ id: footballTeam?.sportTeamId, name: footballTeam?.teamName }}
                                        onChange={(e: any, val: any) =>
                                            setFootballTeam({
                                                ...footballTeam,
                                                sportTeamId: val?.id,
                                                teamName: val?.name,
                                                name: '',
                                                isOther: val?.isOther,
                                            })
                                        }
                                        getOptionLabel={(option: any) => (option && option?.name ? option?.name : '')}
                                        options={footballTeams?.items.length > 0 ? footballTeams?.items : []}
                                        className="autocomplete-05"
                                        renderInput={params => (
                                            <div ref={params.InputProps.ref} className="render-container">
                                                <input
                                                    {...params.inputProps}
                                                    className="render-input-teams"
                                                    placeholder={words && words['WEB.noInformationShared']}
                                                />
                                                {isEdit && <SelectArrowIcon className="red-arrow" />}
                                            </div>
                                        )}
                                    />
                                </>
                                {footballTeam?.isOther && (
                                    <div
                                        className={
                                            isTouched && !footballTeam?.name
                                                ? 'c-unit-01 form-group-04 others error'
                                                : 'c-unit-01 form-group-04 others'
                                        }>
                                        <label className="label-01">{words && words['WEB.OTHER']}</label>
                                        <TextField
                                            disabled={!isEdit}
                                            className={isTouched && !footballTeam?.name ? 'textfield-02 error' : 'textfield-02'}
                                            name="footballOtherTeam"
                                            value={footballTeam?.name?.length > 0 ? footballTeam?.name : ''}
                                            id={'footballOtherTeam-' + footballTeam?.name}
                                            onChange={(e: any) =>
                                                setFootballTeam({
                                                    ...footballTeam,
                                                    name: e?.target?.value?.trim()?.length > 0 ? e?.target?.value : '',
                                                })
                                            }
                                            placeholder={words && words['WEB.noInformationShared']}
                                        />
                                        {isTouched && !footballTeam?.name && (
                                            <span className="validation-error-message-01">*{words && words['WEB.requiredField']}</span>
                                        )}
                                    </div>
                                )}
                            </div>

                            <div className="c-unit-01 form-group-04">
                                <>
                                    <label className="label-01">{words && words['WEB.voleyballTeams']}</label>
                                    <Autocomplete
                                        noOptionsText={words && words['WEB.resultNotFounded']}
                                        disabled={!isEdit}
                                        fullWidth={true}
                                        PopperComponent={CustomPopper}
                                        closeIcon=""
                                        id={'interestsCategory-' + voleyballTeam.sportTeamId}
                                        value={{ id: voleyballTeam?.sportTeamId, name: voleyballTeam?.teamName }}
                                        onChange={(e: any, val: any) =>
                                            setVoleyballTeam({
                                                ...voleyballTeam,
                                                sportTeamId: val?.id,
                                                teamName: val?.name,
                                                name: '',
                                                isOther: val?.isOther,
                                            })
                                        }
                                        getOptionLabel={(option: any) => (option && option?.name ? option?.name : '')}
                                        options={voleyballTeams?.items.length > 0 ? voleyballTeams?.items : []}
                                        className="autocomplete-05"
                                        renderInput={params => (
                                            <div ref={params.InputProps.ref} className="render-container">
                                                <input
                                                    {...params.inputProps}
                                                    className="render-input-teams"
                                                    placeholder={words && words['WEB.noInformationShared']}
                                                />
                                                {isEdit && <SelectArrowIcon className="red-arrow" />}
                                            </div>
                                        )}
                                    />
                                </>
                                {voleyballTeam?.isOther && (
                                    <div
                                        className={
                                            isTouched && !voleyballTeam.name
                                                ? 'c-unit-01 form-group-04 others error'
                                                : 'c-unit-01 form-group-04 others'
                                        }>
                                        <label className="label-01">{words && words['WEB.OTHER']}</label>
                                        <TextField
                                            disabled={!isEdit}
                                            className={isTouched && !voleyballTeam.name ? 'textfield-02 error' : 'textfield-02'}
                                            name="voleyballOtherTeam"
                                            value={voleyballTeam?.name?.length > 0 ? voleyballTeam?.name : ''}
                                            id={'voleyballOtherTeam-' + voleyballTeam.name}
                                            onChange={(e: any) => {
                                                setVoleyballTeam({
                                                    ...voleyballTeam,
                                                    name: e?.target?.value?.trim()?.length > 0 ? e?.target?.value : '',
                                                });
                                            }}
                                            placeholder={words && words['WEB.noInformationShared']}
                                        />
                                        {isTouched && !voleyballTeam.name && (
                                            <span className="validation-error-message-01">*{words && words['WEB.requiredField']}</span>
                                        )}
                                    </div>
                                )}
                            </div>
                            <div className="c-unit-01 form-group-04">
                                <label className="label-01">{words && words['WEB.OTHER']}</label>
                                <TextField
                                    disabled={!isEdit}
                                    className="textfield-02"
                                    name="otherTeam"
                                    id={'otherTeam-' + otherTeam?.name}
                                    value={otherTeam?.name?.length > 0 ? otherTeam?.name : ''}
                                    onChange={(e: any) =>
                                        setOtherTeam({
                                            ...otherTeam,
                                            name: e.target.value.trim().length > 0 ? e.target.value : '',
                                            sportTeamId: otherTeams?.items[0]?.id,
                                        })
                                    }
                                    placeholder={words && words['WEB.noInformationShared']}
                                />
                            </div>
                        </div>
                    </div>
                </AccordionDetails>
            </Accordion>
        </div>
    );
};
export default Teams;
